<div *ngIf="highschoolChartData">
    <h4>Bookings</h4>
    <p-chart #chart type="line" [data]="highschoolChartData" width="700px" height="500px"
        [responsive]="false"></p-chart>

    <h4>Duration (days)</h4>
    <div *ngIf="highschoolChartData">
        <p-chart #chart type="line" [data]="highschoolDurationChartData" width="700px" height="500px"
            [responsive]="false"></p-chart>
    </div>
</div>